import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'OliveCash',
  description:
    'The most popular AMM on BSC by user count! Earn OLIVE through yield farming or win it in the Lottery, then stake it in Olive Garden Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by PancakeSwap), NFTs, and more, on a platform you can trust.',
  image: 'https://pancakeswap.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  switch (path) {
    case '/':
      return {
        title: `${t('Home')} | ${t('OliveCash')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('OliveCash')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('OliveCash')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('OliveCash')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('OliveCash')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('OliveCash')}`,
      }
    case '/collectibles':
      return {
        title: `${t('Collectibles')} | ${t('OliveCash')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('OliveCash')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('OliveCash')}`,
      }
    case '/profile/tasks':
      return {
        title: `${t('Task Center')} | ${t('OliveCash')}`,
      }
    case '/profile':
      return {
        title: `${t('Your Profile')} | ${t('OliveCash')}`,
      }
    default:
      return null
  }
}
